import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  gap: 20px;\n  width: 100%;\n  flex-wrap: wrap;\n  @media (max-width: 1080px) {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n  @media (max-width: 920px) {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n  @media (max-width: 768px) {\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n  }\n\n  .book-info-wrapper {\n    min-width: 180px;\n    width: 100%;\n    flex: 1 1 0;\n    flex-direction: column;\n    gap: 8px;\n\n    img {\n      width: 92px;\n    }\n\n    .thumb-wrapper {\n      display: flex;\n      box-sizing: border-box;\n      flex-direction: column;\n      width: 100%;\n      padding: 8px;\n      height: 224px;\n      padding-bottom: 40px;\n    }\n\n    > div {\n      position: relative;\n    }\n\n    .preview-btn {\n      bottom: 8px;\n      left: 8px;\n      right: 8px;\n      width: auto;\n      text-align: center;\n    }\n  }\n\n  @media (max-width: 768px) {\n    .book-info-wrapper {\n      //width:100% ;\n      min-width: 173px;\n\n      .thumb-wrapper {\n        height: 150px;\n        padding-bottom: 8px;\n\n        img {\n          width: 68px;\n        }\n      }\n    }\n\n    .preview-btn {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CategoryListPageSkeletonItem } from "@/components/Categories/Menu/CategoryListPageSkeleton";
import { EmptyWrapper } from "@/components/Coupons/Mypage/EmptyWrapper";
import { BookCard } from "@/components/Landing/BookCard";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { styled } from "@mui/material";
export const CategoryProductListView = (param)=>{
    let { isLoadingListItem , items , limit  } = param;
    const { isLoggedIn  } = useAuthStore();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(GridContainer, {
                children: isLoadingListItem ? Array.from({
                    length: limit
                }).map((item, idx)=>{
                    return /*#__PURE__*/ _jsx(CategoryListPageSkeletonItem, {}, idx);
                }) : items.map((product, idx)=>{
                    return /*#__PURE__*/ _jsx(BookCard, {
                        book: product,
                        index: idx,
                        positionType: "curation",
                        mixpanelPosition: "카테고리",
                        onClick: ()=>{
                            //mx-48
                            mixpanelEvent("Category Product Clicked", {
                                subject: product.subject,
                                productId: product.id,
                                productTitle: product.title,
                                productType: "handout",
                                isLoggedIn,
                                price: product.price,
                                authorName: product.author,
                                "Coupon Badge": product === null || product === void 0 ? void 0 : product.isCouponAvailable,
                                "Edit Badge": product === null || product === void 0 ? void 0 : product.isEditable,
                                "Review Badge": (product === null || product === void 0 ? void 0 : product.rating) >= 3
                            });
                        }
                    }, idx);
                })
            }),
            !isLoadingListItem && items.length === 0 && /*#__PURE__*/ _jsx(EmptyWrapper, {
                description: "해당하는 상품이 없어요."
            })
        ]
    });
};
const GridContainer = styled("div")(_templateObject());
